'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Hide.tsx
var SvgHide = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.53 2.47a.75.75 0 0 0-1.06 1.06l16.5 16.5a.75.75 0 1 0 1.06-1.06L5.53 2.47Zm5.357 3.357A8.11 8.11 0 0 1 12 5.75c2.365 0 4.349 1.026 5.906 2.305 1.559 1.28 2.646 2.782 3.195 3.637.075.117.107.168.128.208a.165.165 0 0 1 .018.043l.001.01a.54.54 0 0 1 0 .094l-.001.01a.165.165 0 0 1-.018.043c-.021.04-.053.091-.128.208-.28.436-.703 1.045-1.261 1.71a.75.75 0 0 0 1.148.964 18.244 18.244 0 0 0 1.375-1.864l.023-.035c.12-.187.254-.395.323-.69a1.89 1.89 0 0 0 0-.787c-.069-.294-.203-.502-.323-.69l-.023-.034c-.595-.927-1.78-2.57-3.505-3.986C17.131 5.476 14.821 4.25 12 4.25a9.61 9.61 0 0 0-1.319.09.75.75 0 0 0 .206 1.487ZM6.455 7.769a.75.75 0 1 0-.91-1.193C3.6 8.06 2.275 9.886 1.637 10.882l-.023.035c-.12.187-.254.395-.323.69-.055.236-.055.55 0 .787.069.294.203.502.323.69l.023.034c.594.927 1.78 2.57 3.505 3.986C6.869 18.524 9.179 19.75 12 19.75c1.915 0 3.598-.566 5.02-1.375a.75.75 0 0 0-.74-1.304c-1.242.705-2.671 1.179-4.28 1.179-2.365 0-4.349-1.026-5.906-2.305-1.559-1.28-2.646-2.782-3.195-3.637a3.298 3.298 0 0 1-.128-.208.165.165 0 0 1-.018-.043l-.001-.01a.508.508 0 0 1 .001-.104.166.166 0 0 1 .018-.043c.021-.04.053-.091.128-.208.591-.922 1.805-2.588 3.556-3.923Zm3.6 3.033a.75.75 0 1 0-1.261-.812A3.702 3.702 0 0 0 8.203 12c0 2.082 1.71 3.75 3.797 3.75.676 0 1.313-.175 1.865-.483a.75.75 0 0 0-.73-1.31A2.32 2.32 0 0 1 12 14.25c-1.28 0-2.297-1.018-2.297-2.25 0-.441.128-.851.352-1.198Z" }));
var Hide_default = SvgHide;

module.exports = Hide_default;
